import { get, post, postFormData, dlt } from './Api';

const endpoint = 'dynamics';

export const syncAccounts = async () => await get(`${endpoint}/sync-accounts`);
export const syncContacts = async () => await get(`${endpoint}/sync-contacts`);
